import script from "./BalTextInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./BalTextInput.vue?vue&type=script&setup=true&lang=ts"

import "./BalTextInput.vue?vue&type=style&index=0&id=7f50c200&scoped=true&lang=css"
script.__scopeId = "data-v-7f50c200"

export default script